<fibra-toast-error-message [color]="typToastColor"></fibra-toast-error-message>
<div class="main-selector">
    <fibra-company-list></fibra-company-list>
    <default-company-list></default-company-list>
    <div class="main-divisor"></div>
    <fibra-profile-list *ngIf="!loading" funcionalidade="EXT"></fibra-profile-list>
</div>
<fibra-toast-error-message [color]="typToastColor"></fibra-toast-error-message>
<bfd-breadcrumb roule="Extrato" [downloadDoc]="true" (infoReport)="exportScreen($event)"></bfd-breadcrumb>
<div class="content-page" *fibraHasRole="'EXT.CONS_EXT_SAL'">
    <bfd-tab-menu [menus]="menu" [prefix]="mainPrefix" (menusEmitter)="changePage($event)"></bfd-tab-menu>
    <ng-container [ngSwitch]="view">
    <bfd-extract-general-view *ngSwitchCase="'view-1'"></bfd-extract-general-view>
    <bfd-extract-scheduling *ngSwitchCase="'view-2'"></bfd-extract-scheduling>
    <bfd-extract-consolidated-extracts *ngSwitchCase="'view-3'"></bfd-extract-consolidated-extracts>
    </ng-container>
</div>
<bfd-container-display-message *fibraHasRole="'!EXT.CONS_EXT_SAL'" [content]="noPermission"></bfd-container-display-message>

<div style="margin-left: 400px;">
    <section class="body-content report" id="body-report" *ngIf="report" style="position: absolute;">
        <fibra-extract-report id="report" (closeReport)="changeReportView($event)"></fibra-extract-report>
    </section>
</div>